import { m } from 'framer-motion';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Container, Typography, Stack, IconButton } from '@mui/material';
// components
import { useSettingsContext } from '../../../components/minimal/settings/index.jsx';
import SvgColor from '../../../components/minimal/svg-color/index.jsx';
import Image from '../../../components/minimal/image/index.jsx';
import { MotionViewport, varFade } from '../../../components/minimal/animate/index.jsx';
import MainImg from '../../../assets/images/home/new.png'
// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(10, 0),
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundImage: `url('/assets/background/overlay_4.jpg')`,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(20, 0),
  },
}));

// ----------------------------------------------------------------------

export default function HomeDarkMode() {

  return (
    <StyledRoot sx={{ mt: 10 }}>
      <Container component={MotionViewport}>

        {/*<m.div variants={varFade().inUp}>*/}
        {/*  <Stack spacing={2} direction="row" alignItems="center" display="inline-flex">*/}
        {/*    <Typography variant="h2" sx={{ my: 3, color: 'common.white' }}>*/}
        {/*      העסק שלך הדומיין שלך*/}
        {/*    </Typography>*/}

        {/*  </Stack>*/}
        {/*</m.div>*/}

        <m.div variants={varFade().inUp}>
          <Typography variant="h4" sx={{ color: 'grey.500' }}>
            ממשק ניהול ידידותי ועוצמתי שעוד לא ראיתם כמותו
          </Typography>
        </m.div>

        <m.div variants={varFade().inUp}>
          <Image
            alt="darkmode"
            src={MainImg}
            sx={{
              borderRadius: 2,
              my: { xs: 5, md: 10 },
              boxShadow: (theme) => `-40px 40px 80px ${alpha(theme.palette.common.black, 0.24)}`,
            }}
          />
        </m.div>
      </Container>
    </StyledRoot>
  );
}
